export default {
  inserted: function(el) {
    const removeClass = () => {
      const $qlBubble = el.querySelector('.ql-bubble'),
        $qlHidden = $qlBubble.querySelector('.ql-tooltip')

      $qlHidden.classList.remove('ql-hidden')
    }

    el.addEventListener('click', removeClass)
    el.addEventListener('keyup', removeClass)
  },
}
